import { render, staticRenderFns } from "./prima-nota.vue?vue&type=template&id=4eede14a&lang=html&"
import script from "./prima-nota.vue?vue&type=script&lang=js&"
export * from "./prima-nota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports